import {Typography} from '@/components/Typography';
import {FootTrafficResult} from '@/map/@types/foot-traffic';
import {FOOTTRAFFIC_TOP_PERCENTAGE} from '@/map/constants';
import {getFootTrafficTileColor} from '@/map/utils';
import {Flexbox, Section} from '@/styled-components';
import {palette} from '@/styles';
import {withComma} from '@/utils';
import {ColorCircle, SubText} from '../StyledComponents';

export interface IProps {
  data?: FootTrafficResult;
}

export const FootTrafficTopPercent = ({data}: IProps) => {
  if (!data || !data.dataIndex) {
    return;
  }

  const limitPercent =
    FOOTTRAFFIC_TOP_PERCENTAGE[FOOTTRAFFIC_TOP_PERCENTAGE.length - 1];
  const dataIndex = data.dataIndex;

  const minCount = Math.min(
    FOOTTRAFFIC_TOP_PERCENTAGE.length,
    dataIndex.length
  );

  return (
    <div>
      {dataIndex.map((range, idx) => {
        if (idx >= minCount) return null;

        const suffixIdx = range.findIndex((r) => r === -1);
        const suffix = suffixIdx === -1 ? '' : suffixIdx ? '이상' : '이하';
        const percent = FOOTTRAFFIC_TOP_PERCENTAGE[idx];
        const color = getFootTrafficTileColor(percent);

        return (
          <Section spacing={idx === 0 ? 0 : 1} key={idx}>
            <Flexbox>
              <ColorCircle
                color={color.fillColor}
                style={{
                  opacity: color.fillOpacity,
                }}
              />
              <SubText>
                {idx === 0
                  ? `~상위 ${percent}%`
                  : `${FOOTTRAFFIC_TOP_PERCENTAGE[idx - 1] + 1}%~${percent}%`}
                &nbsp;
                <strong>
                  {range
                    .filter((r) => r >= 0)
                    .map((r) => withComma(Math.round(r)))
                    .join('~')}
                  명 {suffix}
                </strong>
              </SubText>
            </Flexbox>
          </Section>
        );
      })}
      <Section spacing={1}>
        <Typography variant="medium10" as="div" color={palette.blue100}>
          * 유동인구 밀도가 높았던 상위 {limitPercent}% 지역을 표시합니다.
        </Typography>
      </Section>
    </div>
  );
};
